module.exports = __webpack_public_path__ + "img/sacrra.e2266d97.svg";